import { useMemo } from 'react';

import { PEOPLE_ACCESS_TABS, UNAUTHORIZED_MODES } from '../constants';
import { usePermissions } from './usePermission.js';

/** Tabs the viewer may see: allowed ones, plus the locked ones in `lock` mode. */
export const usePeopleAccessTabs = () => {
  const { check } = usePermissions();

  return useMemo(
    () =>
      PEOPLE_ACCESS_TABS.filter((tab) => {
        const { allowed, mode } = check(tab.permission);
        return allowed || mode === UNAUTHORIZED_MODES.LOCK;
      }),
    [check],
  );
};
